import { render, staticRenderFns } from "./info-table-view.vue?vue&type=template&id=1b166086&scoped=true"
import script from "./info-table-view.ts?vue&type=script&lang=ts&external"
export * from "./info-table-view.ts?vue&type=script&lang=ts&external"
import style0 from "./info-table-view.less?vue&type=style&index=0&id=1b166086&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b166086",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b166086')) {
      api.createRecord('1b166086', component.options)
    } else {
      api.reload('1b166086', component.options)
    }
    module.hot.accept("./info-table-view.vue?vue&type=template&id=1b166086&scoped=true", function () {
      api.rerender('1b166086', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info-table/info-table-view.vue"
export default component.exports